// MUI
import { Typography } from "@mui/material";
// CUSTOM COMPONENTS
import ActionCard from "@Layouts/components/Cards/ActionCard/ActionCard";
// TYPES
import { IPositionQueue, IUserQueue } from "@/Settings/types/QueueMapping/QueueMapping";

interface IQueuePositionUserProps {
	position: string;
	user: IUserQueue;
	selectedUsers: IPositionQueue[];
	handleSelectUser: (position: string, user: IUserQueue) => void;
}
const QueuePositionUser = (props: IQueuePositionUserProps) => {
	const { user, selectedUsers, handleSelectUser, position } = props;

	return (
		<ActionCard
			checkbox={true}
			checked={selectedUsers.some((pos) => {
				if (pos.name === position) {
					return pos.users.some((u) => u._id === user._id);
				}
				return false;
			})}
			classes="action-card-small-padding action-card-user pb-[2px] [&>.card-header-padding-top-5.MuiCardHeader-root]:pt-[4px] min-h-[32px]"
			title={
				<Typography className="regular-pt-sans-pro-narrow-label bold !text-[14px] !w-[208px]" noWrap>
					{user.name}
				</Typography>
			}
			onChange={() => handleSelectUser(position, user)}
		/>
	);
};

export default QueuePositionUser;
